import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface AppsStoreBannerProps {
  title: React.ReactNode;
  description: React.ReactNode;
  backgroundUrl: string;
}

/*
 * Style.
 */

interface StyledBannerWrapperDivProps {
  $backgroundUrl: string;
}

const StyledBannerWrapperDiv = styled.div<StyledBannerWrapperDivProps>`
  display: flex;
  flex-flow: column;
  justify-content: center;
  gap: 8px;
  border-radius: 16px;
  padding: 20px;
  flex: 0 0 320px;
  margin-bottom: 30px;

  ${(p) => css`
    background: url(${p.$backgroundUrl});
    background-color: ${p.theme.greys.shade20};
    background-position: center;
    background-size: cover;
  `};
`;

const StyledTitleWrapperDiv = styled.div`
  font-size: 24px;
  font-weight: ${fontWeights.black};
`;

const StyledDescriptionWrapperDiv = styled.div`
  font-size: ${fontSizes.large};
  max-width: 50%;
  line-height: 24px;

  @media only screen and (max-width: 900px) {
    max-width: 100%;
  }
`;

/*
 * Component.
 */

export const AppsStoreBanner: FC<AppsStoreBannerProps> = ({title, description, backgroundUrl}) => (
  <StyledBannerWrapperDiv $backgroundUrl={backgroundUrl}>
    <StyledTitleWrapperDiv>{title}</StyledTitleWrapperDiv>
    <StyledDescriptionWrapperDiv>{description}</StyledDescriptionWrapperDiv>
  </StyledBannerWrapperDiv>
);
